module.exports = __webpack_public_path__ + "img/new12.d0648544.jpg";